<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <card bodyClasses="table-full-width">
          <h4 slot="header" class="card-title text-left">Striped table</h4>
          <el-table :data="tableData">
            <el-table-column
              min-width="150"
              sortable
              label="Name"
              property="name"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              label="Country"
              property="country"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              label="City"
              property="city"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              align="right"
              header-align="right"
              label="Salary"
              property="salary"
            ></el-table-column>
          </el-table>
        </card>
      </div>

      <div class="col-md-12">
        <card class="card-plain" body-classes="table-full-width">
          <template slot="header">
            <h4 class="card-title text-left">Table on Plain Background</h4>
            <p class="category text-left">Here is a subtitle for this table</p>
          </template>
          <el-table
            header-cell-class-name="table-transparent"
            header-row-class-name="table-transparent"
            row-class-name="table-transparent"
            :data="tableData"
          >
            <el-table-column
              min-width="150"
              sortable
              label="Name"
              property="name"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              label="Country"
              property="country"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              label="City"
              property="city"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              align="right"
              header-align="right"
              label="Salary"
              property="salary"
            ></el-table-column>
          </el-table>
        </card>
      </div>

      <div class="col-md-12">
        <card body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            Regular Table with Colors
          </h4>
          <el-table :row-class-name="tableRowClassName" :data="tableData">
            <el-table-column
              min-width="150"
              sortable
              label="Name"
              property="name"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              label="Country"
              property="country"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              label="City"
              property="city"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              align="right"
              header-align="right"
              label="Salary"
              property="salary"
            ></el-table-column>
          </el-table>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Card } from "@/components/index";
import { Table, TableColumn } from "element-ui";

export default {
  components: {
    Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      tableData: [
        {
          id: 1,
          name: "Dakota Rice",
          salary: "$36.738",
          country: "Niger",
          city: "Oud-Turnhout"
        },
        {
          id: 2,
          name: "Minerva Hooper",
          salary: "$23,789",
          country: "Curaçao",
          city: "Sinaai-Waas"
        },
        {
          id: 3,
          name: "Sage Rodriguez",
          salary: "$56,142",
          country: "Netherlands",
          city: "Baileux"
        },
        {
          id: 4,
          name: "Philip Chaney",
          salary: "$38,735",
          country: "Korea, South",
          city: "Overland Park"
        },
        {
          id: 5,
          name: "Doris Greene",
          salary: "$63,542",
          country: "Malawi",
          city: "Feldkirchen in Kärnten"
        }
      ]
    };
  },
  methods: {
    tableRowClassName({ rowIndex }) {
      if (rowIndex === 0) {
        return "table-success";
      } else if (rowIndex === 2) {
        return "table-info";
      } else if (rowIndex === 4) {
        return "table-danger";
      } else if (rowIndex === 6) {
        return "table-warning";
      }
    }
  }
};
</script>
<style></style>
